import { customSVGs } from '../components/customSvgs';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/lib/iconsets/mdi';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

async function checkPrimaryColorAvailable(resolve) {
    if (
        String(
            getComputedStyle(document.documentElement).getPropertyValue(
                '--primary-main'
            )
        )?.trim()
    ) {
        resolve(true);
    } else {
        console.log("--awaiting color")
        await new Promise((res) => setTimeout(res, 100));
        return await new Promise(() => checkPrimaryColorAvailable(resolve));
    }
}
export default async function (vueInstance) {
    await new Promise((resolve) => checkPrimaryColorAvailable(resolve));

    const vuetify = createVuetify({
        theme: {
            defaultTheme: 'light',
            themes: {
                light: {
                    dark: false,
                    colors: {
                        primary: String(
                            getComputedStyle(
                                document.documentElement
                            ).getPropertyValue('--primary-main')
                        )?.trim(),
                        secondary: String(
                            getComputedStyle(
                                document.documentElement
                            ).getPropertyValue('--secondary-main')
                        )?.trim(),
                        accent: String(
                            getComputedStyle(
                                document.documentElement
                            ).getPropertyValue('--tertiary-main')
                        )?.trim(),
                        background: String(
                            getComputedStyle(
                                document.documentElement
                            ).getPropertyValue('--ui-general-background-02')
                        )?.trim(),
                        surface: String(
                            getComputedStyle(
                                document.documentElement
                            ).getPropertyValue('--ui-general-background-01')
                        )?.trim(),
                    },
                    variables: {},
                },
            },
        },
        icons: {
            defaultSet: 'mdi',
            aliases,
            sets: {
                mdi,
                custom: customSVGs,
            },
        },
        components,
        directives,
    });
    vueInstance.appContext.app.use(vuetify); 
}
